


























































import { Component,Model, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { GapDateFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";
import { GapStatusSummaryReportFilter } from "@/store/modules/types";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class CreatedDateFilter extends Vue {
 @Model("change") readonly filter!: GapStatusSummaryReportFilter;
  id = "created-date-filter-popover";
  target = "created-date-filter-target";
  defaultFilter(): GapDateFilter {
    return {
      from: null,
      to: null,
    };
  }

  setToday() {
    const today = new Date();
    this.filter.createdDate.from = today;
    this.filter.createdDate.to = today;
    this.search();
  }
  
  search() {
    this.$emit('refresh')
    this.close();
  }
  clear() {
    this.filter.createdDate = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {

  }
}
